// extracted by mini-css-extract-plugin
module.exports = {"honeypot":"styles_honeypot__9dUEq"};